import { css } from '@emotion/react';

export const skeletonCss = css`
  transform: unset;
`;
